var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 47 47"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB004B",
    d: "M47 23.5C47 36.478 36.478 47 23.5 47S0 36.478 0 23.5 10.522 0 23.5 0 47 10.522 47 23.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.408 28.233v-3.756h-5.166v3.756H7.833V18.75h2.409v3.73h5.166v-3.73h2.395v9.484h-2.395Zm6.35-5.103v-2.434h3.408c1.073 0 1.473.485 1.473 1.184 0 .7-.411 1.248-1.41 1.248H21.76l-.002.002Zm5.23 1.647c1.298-.4 2.071-1.373 2.071-2.957 0-2.235-1.435-3.07-3.781-3.07H19.35v9.483h2.409v-3.157h2.77l2.047 3.157h2.72l-2.308-3.456Zm9.795.674c0 .761-1.048.961-2.458.961-1.872 0-3.507-.4-4.23-.736v2.109c1.062.325 2.372.574 4.23.574 3.157 0 4.841-.8 4.841-3.02 0-1.947-1.135-2.595-4.617-2.808-1.622-.1-2.147-.2-2.147-.948s.999-1.01 2.32-1.01c1.736 0 3.283.399 3.92.724v-2.11c-.8-.299-2.098-.561-3.808-.561-3.53 0-4.817 1.085-4.817 3.068 0 1.984 1.122 2.595 4.63 2.809 1.61.1 2.134.2 2.134.948"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h47v47H0z"
  })))));
};
export default SvgLogo;